import React from "react";
import TranslatedKey from "./TranslatedKey";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";

const ConfiguratorSurveyBlockHeader = ({
  isInline,
  title,
  description,
  image_filename,
  required,
  hidden,
  type = "step",
  realtime,
}) => {
  const textTitle = realtime
    ? "text-xl"
    : type === "step"
    ? "text-4xl"
    : type === "alert"
    ? "text-xl"
    : "text-3xl";
  const boxMb = type === "alert" ? "" : "mb-4";
  return (
    <>
      {isInline ? (
        (description ? <div>
          <p className="text-base">
            {description ? <TranslatedKey id={description}/> : null}
          </p>
        </div> : null)
      ) : (
        <div
          className={`flex w-full justify-between items-center ${boxMb} ${hidden}`}
        >
          <div className="flex flex-col">
            {title ? (
              <div className="mb-1 flex items-center">
                <div>
                  <h2 className={`${textTitle} leading-none`}>
                    <TranslatedKey id={title} />
                  </h2>
                </div>
                {required ? (
                  <div
                    style={{ minWidth: "1.5rem" }}
                    className="w-6 h-6 ml-2 text-gray-400"
                  >
                    <ExclamationCircleIcon />
                  </div>
                ) : null}
              </div>
            ) : null}
            {description ? (
              <div>
                <p className="text-base">
                  <TranslatedKey id={description} />
                </p>
              </div>
            ) : null}
          </div>
          {image_filename ? (
            <div>
              <div
                className="w-14 h-14 bg-cover bg-center relative"
                style={{
                  backgroundImage: `url(${"/" + image_filename})`,
                }}
              />
            </div>
          ) : null}
        </div>
      )}
    </>
  );
};

export default ConfiguratorSurveyBlockHeader;
